import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";

const perPage = 20;

const MultiProductGroupList = (props: MultiPickerListProps<server.dto.ProductGroup>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListProductGroupInstruction>({
    keyword: "",
    page: 1,
    perPage: perPage,
  });

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="productGroups"
    api={window.CoreApi.ProductGroup.Paginated}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    getId={pg => pg.productGroupId}
    renderListItem={pg => <div>{pg.title}</div>}
    getLabel={pg => <div>{pg.title}</div>}
    value={props.value}
  />
};

export default MultiProductGroupList;